'use client';

import FullWrapper from 'core/FullWrapper';
import React from 'react';

import ContentBlock from '~/components/features/cases/RenessansBank/content-block';

import TeamCase from '../OldComponents/case-components/team-case';
import NextProject from '../OldComponents/cases/reusable-components/layouts-components__common-cases/next-project';
import Target from '../OldComponents/cases/reusable-components/target';
import Calculator from './calculator';
import {
    listChallenge,
    listEvolution,
    listPath,
    listProblems,
    listTeam,
    listTitle,
    targetList,
} from './constans';
import Decision from './decision';
import Development from './development';
import Problem from './problem';
import Process from './process';
import Results from './results';
import TitleCase from './title-case';

const nextProjectdevRec = {
    nextProjectTitle: 'SkillsTeam',
    nextProjectImg: '/images/pic/cases-list-images/skillsPoster.jpg',
    nextProjectLink: '/cases/development/skills-team',
    nextProjectLinkTitle: '',
    nextProjectText: 'Российская система управления грейдами',
};

const TalentMind = () => {
    return (
        <section>
            <TitleCase
                //video="/video/talent-mind-video.mp4"
                img="/images/pic/talent-mind/talent-mind-head.png"
                listPath={listPath}
                listTitle={listTitle}
                caseName="talent-mind"
            />

            <Target title={targetList.title} description={targetList.description} />

            <FullWrapper>
                <ContentBlock title={listChallenge.title}>{listChallenge.content}</ContentBlock>
            </FullWrapper>

            <Problem />

            <Decision />

            <Process />

            <Development />

            <Calculator />

            <FullWrapper>
                <ContentBlock title={listProblems.title}>{listProblems.content}</ContentBlock>
            </FullWrapper>

            <Results />

            <FullWrapper>
                <ContentBlock title={listEvolution.title}>{listEvolution.content}</ContentBlock>
            </FullWrapper>

            <TeamCase listTeam={listTeam} />

            <NextProject NextProject={nextProjectdevRec} />
        </section>
    );
};

export default TalentMind;
